import { MiTHEME } from "@miplatform/theme";
import { ICON_TYPES } from "../iconTypes/iconTypes";
import { ICONS_NATIVE_CONTROLS } from "../icons/icons";
import { PLATFORM_MODULES } from "../platform/modules";

export const WORK = "Work";
export const MY_WORK = "My Work";
export const ATTEMPTS = "Attempts";
export const REVIEW_WORK = "Review Work";
export const JOB = "Job";
export const TASKS = "Tasks";
export const DETAILS = "Details";
export const ITEMS = "Items";
export const PREFERENCES = "Preferences";
export const ISSUE_TEMPLATES = "Issue Templates";
export const RESOURCE_GORUP = "Resource Groups";
export const MEMBERS = "Members";
export const PHOTOS = "Photos";
export const ISSUES = "Issues";
export const STEP_TEMPLATES = "Step Templates";
export const ASSIGNMENT_TEMPLATES = "Assignment Templates";

export const ATTEMPT_TYPE_FILTER = "assignment.assignmentTemplateName";
export const COMMUNITY_FILTER = "communityId";

export const CDN_URL = "https://docteststor.blob.core.windows.net/images/";

export const ADMIN_SETTING_PAGE_USER_MANAGEMENT = "userManagement";
export const ADMIN_SETTING_PAGE_ORDER_MANAGEMENT = "orderManagement";
export const ADMIN_SETTING_PAGE_CITY_MANAGEMENT = "cityManagement";
export const ADMIN_SETTING_PAGE_ACCOUNTING_MANAGEMENT = "accountingManagement";
export const ADMIN_SETTING_PAGE_CALENDAR_MANAGEMENT = "calendarManagement";
export const ADMIN_SETTING_PAGE_DOCUMENT_MANAGEMENT = "documentManagement";
export const ADMIN_SETTING_PAGE_MILESTONE_MANAGEMENT = "milestoneManagement";
export const ADMIN_SETTING_PAGE_RELATIONSHIP_MANAGEMENT =
  "relationshipManagement";
export const ADMIN_SETTING_PAGE_PROFILE_MANAGEMENT = "profileManagement";

export const NAV_ITEM_GROUPS = {
  MODULES: "MODULES",
  GENERAL: "GENERAL",
  SETTINGS: "SETTINGS",
  ADMIN: "ADMIN",
  NO_GROUP_NAME: "UNDEFINED",
};

export const APP_SIDE_NAV_FULL_WIDTH = 344;
export const APP_SIDE_NAV_WIDTH = 172;
export const APP_SIDE_NAV_WIDTH_COLLAPSED = 60;
export const APP_SUB_NAV_WIDTH_COLLAPSED = 24;

export const APP_BAR_HEIGHT = 60;
export const APP_BAR_HEIGHT_TABLET = 96;
export const MIBUILD_PAGE_HEADER_HEIGHT = 52;
export const DRAWER_WIDTH_FULL = 800;
export const DRAWER_WIDTH_LG = 500;

export const CONFIG_PAGES = {
  HOME: "home",
  ...PLATFORM_MODULES,
  TENANTS: "tenants",
  HR: "hr",
  SETTINGS: "settings",
  ALERTS: "alerts",
  USERS: "users",
  TEAMS: "team",
  CREATE_TEAM: "createTeam",
  ROLES_HR: "rolesHr",
  ROLES_OPERATIONS: "rolesOperations",
  OPERATIONS: "operations",
  ORDER_TEMPLATES: "orderTemplates",
  ORDER_CALENDARS: "orderCalendars",
  WORK_ORDER_CALENDARS: "workOrderCalendars",
  INSPECTION_CALENDARS: "inspectionCalendars",
  STEP_TEMPLATES: "stepTemplates",
  WORK_ORDER_TEMPLATES: "workOrderTemplates",
  WORK_ORDER_STEPS: "workOrderSteps",
  RECORDABLES: "recordables",
  WARRANTY_ITEMS: "warrantyItems",
  DELAYS_LIST: "delaysList",
  CUSTOMERS: "customers",
  VENDORS: "vendors",
  SUBCONTRACTORS: "subcontractors",
  TRADE_TYPES: "tradeTypes",
  HOLD_REASONS: "holdReasons",
  CALENDARS: "calendars",
  NEW_CONSTRUCTION: "newConstruction",
  BUILD_CALENDAR: "buildCalendar",
  PRICING: "pricing",
  LABOR_RATES: "laborRates",
  SETUP: "setup",
  DISPATCH: "dispatch",
  SCHEDULING: "scheduling",
  ACCOUNTING: "accounting",
  INSPECTIONS: "inspections",
  ESTIMATING: "estimating",
  EXAMPLE: "example",
  DEPARTMENTS: "departments",
  DEPARTMENT: "department",
  ADD_DEPARTMENT: "addDepartment",
  COMMUNITIES: "communities",
  DEPARTMENT_USERS: "departmentUsers",
  DEPARTMENT_USER_PROFILE: "departmentUserProfile",
  QUICKBOOKS: "quickBooks",
  QUICKBOOKS_INTEGRATION: "quickBooksIntegration",
  QUICKBOOKS_IMPORT_CUSTOMERS: "quickBooksImportCustomers",
  DOCUMENT_TYPES: "documentTypes",
  PRODUCTION: "production",
  AUTO: "auto",
  AUTO_BUILD: "autoBuild",
  AUTO_TRIGGER: "autoTrigger",
  AUTO_ASSIGN: "autoAssign",
  INSPECTION_TEMPLATES: "inspectionTemplates",
  HOLIDAYS: "holidays",
  MISC: "misc",
  INSPECTION_AUTHORITIES: "inspectionAuthorities",
  CITIES: "cities",
  MIDAY: "miday",
  CANNOT_PERFORM_REASONS: "cannotPerformReasons",
};

export const COLORS = {
  BLUE: "blue",
  RED: "red",
  ERROR: "error",
  WHITE: "white",
  BLACK: "black",
  CYAN: "cyan",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  GREY: "grey",
  PURPLE: "purple",
  ORANGE: "orange",
  SUCCESS: "success",
};

export const BUTTON_COLORS = {
  BLUE: "blue",
  RED: "red",
  ERROR: "error",
  WHITE: "white",
  BLACK: "black",
  CYAN: "cyan",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  GREY: "grey",
  PURPLE: "purple",
  ORANGE: "orange",
  SUCCESS: "success",
};

export const IMAGE_NAME = {
  MIVIEWIS: "MiViewIS.png",
  MIBUILD: "MiBuild.png",
  FILE_CHECK: "FileCheck.png",
  ACCOUNT_OUTLINE: "account-outline.png",
  DOCUMENT_OUTLINE: "file-document-outline.png",
};

export const BUTTON_LABELS = {
  DELETE: "Delete",
  EDIT: "Edit",
  SUBMIT: "Submit",
  SAVE: "Save",
  CANCEL: "Cancel",
  CONTINUE: "Continue",
  NEXT: "Next",
  PREVIOUS: "Previous",
  REMOVE: "Remove",
  DEACTIVATE: "Deactivate",
  ACTIVATE: "Activate",
  VOID: "Void",
  VIEW_DOCUMENT: "View Document",
  DUPLICATE: "Duplicate",
  UNDO: "Undo",
  CONFIRM: "Confirm",
  OK: "OK",
};

export const MODAL_TITLES = {
  DELETE: "Confirm Delete",
  SAVE: "Save Changes",
  CANCEL: "Cancel Editing",
};

export const FILE_UPLOAD_VARIANTS = {
  TEXT: "TEXT",
  BUTTON: "BUTTON",
};

export const BUTTON_VARIANTS = /** @type {const} */ ({
  TEXT: "text",
  OUTLINED: "outlined",
  CONTAINED: "contained",
});

export const BUTTON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};

export const SECTION_HEADER_VARIANTS = {
  UNDERLINED: "underlined",
  OUTLINED: "outlined",
  CONTAINED: "contained",
  TEXT: "text",
};

export const ICON_VARIANTS = {
  STANDARD: "standard",
  OUTLINED: "outlined",
  CONTAINED: "contained",
};

export const DEFAULT_COMMUNITY_COLORS = [
  MiTHEME.palette.pink.light,
  MiTHEME.palette.orange.light,
  MiTHEME.palette.blue.light,
  MiTHEME.palette.lime.light,
  MiTHEME.palette.teal.light,
  MiTHEME.palette.purple.light,
  MiTHEME.palette.bluegrey.extraLight,
  MiTHEME.palette.deepOrange.light,
  MiTHEME.palette.amber.extraLight,
  MiTHEME.palette.lightblue.extraLight,
  MiTHEME.palette.lightGreen.light,
  MiTHEME.palette.lime.extraLight,
  MiTHEME.palette.deepPurple.light,
  MiTHEME.palette.brown.light,
  MiTHEME.palette.deepOrange.extraLight,
  MiTHEME.palette.yellow.light,
  MiTHEME.palette.cyan.light,
  MiTHEME.palette.green.light,
  MiTHEME.palette.lightGreen.extraLight,
  MiTHEME.palette.indigo.light,
  MiTHEME.palette.grey.accent,
];

export const CONFIGURABLE_COLORS = [
  { label: "Blue 10", color: MiTHEME.palette.vibrant.blue_10 },
  { label: "Blue 40", color: MiTHEME.palette.vibrant.blue_40 },
  { label: "Blue 50", color: MiTHEME.palette.vibrant.blue_50 },
  { label: "Green 10", color: MiTHEME.palette.vibrant.green_10 },
  { label: "Green 30", color: MiTHEME.palette.vibrant.green_30 },
  { label: "Neutral 10", color: MiTHEME.palette.vibrant.neutral_10 },
  { label: "Orange 10", color: MiTHEME.palette.vibrant.orange_10 },
  { label: "Orange 20", color: MiTHEME.palette.vibrant.orange_20 },
  { label: "Orange 30", color: MiTHEME.palette.vibrant.orange_30 },
  { label: "Purple 10", color: MiTHEME.palette.vibrant.purple_10 },
  { label: "Purple 30", color: MiTHEME.palette.vibrant.purple_30 },
  { label: "Red 10", color: MiTHEME.palette.vibrant.red_10 },
  { label: "Red 20", color: MiTHEME.palette.vibrant.red_20 },
  { label: "Teal 10", color: MiTHEME.palette.vibrant.teal_10 },
  { label: "Teal 20", color: MiTHEME.palette.vibrant.teal_20 },
];

export const TYPOGRAPHY_VARIANTS = /** @type {const} */ ({
  PAGE_TITLE: "pageTitle",
  LIST_TITLE: "listTitle",
  TITLE: "title",
  HEADER: "header",
  SUBTITLE: "subTitle",
  CAPTION: "caption",
  BUTTON: "button",
  SUBCAPTION: "subCaption",
  INPUT_TEXT: "inputText",
  BODY_TEXT: "bodyText",
  BODY1: "body1",
  BODY2: "body2",
  SUBTITLE2: "subtitle2",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  HD1: "HD1",
  HD2: "HD2",
  HD3: "HD3",
  HD4: "HD4",
  HD5: "HD5",
  HD6: "HD6",
  BD1: "BD1",
  BD2: "BD2",
  BD3: "BD3",
  BM1: "BM1",
  BM2: "BM2",
  BM3: "BM3",
  BM4: "BM4",
  BM5: "BM5",
  PM1: "PM1",
  PM2: "PM2",
});

export const FONT_WEIGHTS = /** @type {const} */ ({
  REGULAR: "400",
  MEDIUM: "500",
  SEMIBOLD: "600",
  BOLD: "700",
});

const ENGLISH = "English";
const SPANISH = "Spanish";
// TODO: Implement language API from backend

export const LANGUAGES = [
  { label: ENGLISH, value: "en" },
  { label: SPANISH, value: "es" },
];

export const CAPTURE_MODES = {
  PHOTO: "photo",
  VIDEO: "video",
};

export const MEDIA_TYPES = {
  IMAGE: "Image",
  VIDEO: "Video",
};

export const RECORD_TYPES = {
  RECORDABLE: "Recordable",
  INTERNAL_DELAY: "InternalDelay",
  PUNCH: "Punch",
  WEATHER: "Weather",
  SERVICE_ITEM: "ServiceItem",
};

export const QUALIFICATION_STATUSES = {
  ACTIVE: "Active",
  DISABLED: "Disabled",
};

export const RESOURCE_STATUSES = {
  [true]: "Active",
  [false]: "Inactive",
};

export const QUALIFICATION_STATUSES_LABEL = {
  [QUALIFICATION_STATUSES.ACTIVE]: "Active",
  [QUALIFICATION_STATUSES.DISABLED]: "Inactive",
};

export const QUALIFICATION_TYPES = {
  SKILL: "Skill",
  RESOURCE_GROUP: "ResourceGroup",
  EQUIPMENT: "Equipment",
};

export const CONTROLS_CONFIG = {
  RETAKE: {
    color: MiTHEME.palette.grey.medium,
    iconName: ICONS_NATIVE_CONTROLS.CAMERA_RETAKE,
    label: "Retake",
  },
  DELETE: {
    color: MiTHEME.palette.red.main,
    iconName: ICONS_NATIVE_CONTROLS.DELETE,
    label: "Delete",
  },
  FAILED: {
    color: MiTHEME.palette.red.main,
    iconName: ICONS_NATIVE_CONTROLS.INCOMPLETE_DOWN,
    label: "Failed",
  },
  HOLD: {
    color: MiTHEME.palette.purple.main,
    iconName: ICONS_NATIVE_CONTROLS.HOLD,
    label: "Hold",
  },
  CLEAR_EDIT: {
    color: MiTHEME.palette.blue.main,
    iconName: ICONS_NATIVE_CONTROLS.UNDO_VARIANT,
    label: "Clear Edits",
  },
  CONTINUE: {
    color: MiTHEME.palette.blue.main,
    iconName: ICONS_NATIVE_CONTROLS.ARROW_RIGHT,
    label: "Continue",
  },
  THUMB_UP: {
    color: MiTHEME.palette.green.main,
    iconName: ICONS_NATIVE_CONTROLS.THUMB_UP,
    label: "Approve",
  },
  THUMB_DOWN: {
    color: MiTHEME.palette.red.dark,
    iconName: ICONS_NATIVE_CONTROLS.THUMB_DOWN,
    label: "Fail",
  },
  CAPTURE: {
    color: MiTHEME.palette.blue.main,
    iconName: ICONS_NATIVE_CONTROLS.CAMERA_OUTLINE,
    label: "Capture",
  },
  NA: {
    color: MiTHEME.palette.grey.medium,
    iconName: ICONS_NATIVE_CONTROLS.NA,
    label: "Not Applicable",
    iconType: ICON_TYPES.MATERIAL,
  },
  UNDO: {
    color: MiTHEME.palette.bluegrey.main,
    iconName: ICONS_NATIVE_CONTROLS.UNDO_VARIANT,
    label: "Undo",
  },
  LINK: {
    color: MiTHEME.palette.purple.main,
    iconName: ICONS_NATIVE_CONTROLS.LINK,
    label: "Link",
  },
  UNLINK: {
    color: MiTHEME.palette.purple.main,
    iconName: ICONS_NATIVE_CONTROLS.UNLINK,
    label: "Unlink",
  },
  VIDEO: {
    color: MiTHEME.palette.blue.main,
    iconName: ICONS_NATIVE_CONTROLS.VIDEO_OUTLINE,
    label: "Capture",
  },
};

export const DATEPICKER_ACTIONS = {
  RESET: "reset",
  CANCEL: "cancel",
  CLEAR: "clear",
  ACCEPT: "accept",
  TODAY: "today",
};

export const DATEPICKER_VARIANTS = {
  INLINE: "inline",
  DESKTOP: "desktop",
  HIGHLIGHT: "highlight",
};

export const DATE_TIME_FORMATS = {
  ISO_8601_EXTENDED_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSSSSSSZ",
  CUSTOM: "ddd, MMM D, YYYY, hh:mm A",
  FORMAT_MM_DD_HH_MM_A: "MMM D, h:mm A",
  TIMESTAMP: "MM/DD/YYYY hh:mm:ss A",
  FORMAT_24_HOUR: "HH:mm",
  FORMAT_12_HOUR: "hh:mm A",
  FORMAT_12_HOUR_SHORT: "hh:mm",
  FORMAT_dddd_MMMM_D_YYYY: "dddd, MMMM D, YYYY",
  FORMAT_MMM_D_YYYY_H_MM_A: "MMM D, YYYY, h:mm A",
  FORMAT_MMMM_D_YYYY: "MMMM D, YYYY",
  FORMAT_YYYY_MM_DD_HH_mm_SS: "YYYY:MM:DD HH:mm:SS",
  FORMAT_YYYY_MM_DD_HH_mm_A: "YYYY-MM-DD HH-mm A",
  FORMAT_YYYY_MM_DD: "YYYY-MM-DD",
  FORMAT_M_D_YY: "M/D/YY",
  FORMAT_MM_DD_YY: "MM/DD/YY",
  FORMAT_M_DD: "M/DD",
  FORMAT_MM_DD_YY_HH_MM_A: "MM/DD/YY h:mm A",
  FORMAT_MM_DD_YYYY: "MM/DD/YYYY",
  FORMAT_MMMM_Do_YYYY: "MMMM Do, YYYY",
  FORMAT_HH_mm_ss: "HH:mm:ss",
  HOURS: "hA",
  HOURS_MINUTES: "h:mm A",
  MINUTES: "minutes",
  FORMAT_DDD: "ddd",
};

export const TIME_UNITS = {
  YEAR: "year",
  MONTH: "month",
  WEEK: "week",
  DAY: "day",
  HOUR: "hour",
  MINUTE: "minute",
  SECOND: "second",
  QUARTER: "quarter",
  ISO_WEEK: "isoWeek", // Start of ISO week (Monday-based)
  DATE: "date",
};

export const DAY_TIME_INTERVALS = {
  MORNING: "Morning",
  AFTERNOON: "Afternoon",
  EVENING: "Evening",
  NIGHT: "Night",
};

export const DAY_TIME_INTERVALS_HOURS = {
  [DAY_TIME_INTERVALS.MORNING]: { start: "7AM", end: "12PM" },
  [DAY_TIME_INTERVALS.AFTERNOON]: { start: "12PM", end: "5PM" },
  [DAY_TIME_INTERVALS.EVENING]: { start: "5PM", end: "9PM" },
  [DAY_TIME_INTERVALS.NIGHT]: { start: "9PM", end: "7AM" },
};

export const MESSAGE_TYPES = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  INFO: "info",
};

export const BOX_SELECTOR_VARIANTS = {
  CHECKBOX: "checkbox",
  RADIO: "radio",
  NONE: "none",
};

export const BOX_SELECTOR_SIZES = {
  BIG: "big",
  SMALL: "small",
};

export const PRINT_OPTIONS = {
  PAGES: "PAGES",
  TABLE: "TABLE",
};

export const DAYS_ORDER = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const FIELDSET_VARIANTS = {
  DEFAULT: "default",
  INVERTED: "inverted",
};

export const DOCUMENT_CATEGORIES = {
  SIGNATURE: "Signature",
  USER_PHOTO: "UserPhoto",
  ATTEMPT_START: "AttemptStartImage",
  RESOURCE_PROFILE_IMAGE: "ResourceProfileImage",
  THUMBNAIL: "Thumbnail",
};

export const ASSIGNMENT_TEMPLATE_TYPES = {
  INSTALL: "Install",
  REVIEW: "Review",
  OFFICE: "Office",
  WARRANTY: "Warranty",
  INSPECTION: "Inspection",
};

export const ATTEMPT_TYPES = {
  INSTALL: "Install",
  REVIEW: "Review",
  OFFICE: "Office",
  WARRANTY: "Warranty",
  INSPECTION: "Inspection",
};

export const ISSUE_AREAS_OPTIONS = [
  { label: "Kitchen", value: "Kitchen" },
  { label: "Garage", value: "Garage" },
  { label: "Master Bath", value: "Master Bath" },
  { label: "Utility Room", value: "Utility Room" },
  { label: "Water Heater", value: "Water Heater" },
  { label: "Laundry Room", value: "Laundry Room" },
  { label: "Powder Bath", value: "Powder Bath" },
  { label: "Outside", value: "Outside" },
];

export const AUTOCOMPLETE_REASON = {
  CLEAR: "clear",
  INPUT: "input",
  RESET: "reset",
  SELECT_OPTION: "select-option",
};

export const NOT_APPLICABLE = "N/A";

export const REASON_GROUPS_NAMES = {
  ORDER_TEMPLATE_HOLD: "OrderHolds",
};

export const DEFAULT_DOCUMENT_CATEGORY = "General";

export const VERTICAL_TABS_BASE_GROUPS = {
  UNASSIGNED: "Unassigned",
  NOT_READY: "Not Ready",
  ASSIGNED: "Assigned",
};

export const AUTO_ASSIGN_STAGING_REASONS = {
  INSUFFICIENT_WINDOW_CAPACITY: "insufficient-window-capacity",
  ALREADY_STAGED: "already-staged",
};
